export const MaxDecimalCount: number = 9
